import { createSlice } from '@reduxjs/toolkit'

const updatedOnSlice = createSlice({
  name: 'updatedOn',
  initialState: null, // Initial value of updatedOn
  reducers: {
    setUpdatedOn: (state, action) => action.payload
  }
})

export const { setUpdatedOn } = updatedOnSlice.actions

export default updatedOnSlice.reducer
